<template>
  <div>
    <div class="subheading grey--text mt-6 ml-3">
      <h5 v-if="receivedTemplates">
        SMS Templates[{{ receivedTemplates.totalRecords }}]
      </h5>
    </div>
    <div class="mx-2">
      <v-data-table
        v-if="receivedTemplates"
        :headers="headers"
        :items="receivedTemplates.templates"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="_id"
        show-expand
        hide-default-footer
        ><template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn
              class="primary white--text lowercase-text"
              plain
              @click="dialogs.create = true"
            >
              Add template
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ item }">
          <!-- <td :colspan="headers.length">More info about {{ item.name }}</td> -->
          <p class="mr-0 ml-2">
            {{ item.message }}
          </p>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | niceDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TemplateMenu :template="item" />
        </template>
      </v-data-table>
      <div class="text-center mt-8">
        <Pagination
          v-if="receivedTemplates"
          store="templates"
          collection="templates"
          action="fetchTemplates"
        />
      </div>
    </div>
    <DialogCreate @close="dialogs.create = false" v-if="dialogs.create" />
  </div>
</template>
<script>
import { format } from "date-fns";
import DialogCreate from "./Dialogs/CreateTemplate";
import TemplateMenu from "@/components/sms/menu/TemplateTableMenu";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: { DialogCreate, TemplateMenu, Pagination },
  data() {
    return {
      dialogs: {
        create: false,
      },
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: "Template name",
          align: "start",
          value: "name",
        },
        { text: "Category", value: "category" },
        { text: "Created At", value: "createdAt" },
        { text: "Content", value: "data-table-expand" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  created() {
    this.$store.dispatch("templates/fetchTemplates", 1);
  },
  computed: {
    receivedTemplates() {
      return this.$store.getters["templates/templates"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
